export const lastRegistrationModel = {
  bedCount: undefined,
  roomCount: undefined,
  name: null, 
  voen: undefined,
  pin: undefined,
  legalAddress: undefined,
  city: undefined,
  groupOfCompanies: null,
  objectRegisterationDate: null,
  objectName: undefined,
  objectAddress: {
    label: undefined,
    lat: undefined,
    lng: undefined
  },
  objectCode: undefined,
  personInChargeName: undefined,
  personInChargePosition: { az: undefined, en: undefined, ru: undefined },
  personInChargePhone: undefined,
  personInChargeEmail: undefined,
  managerName: undefined,
  nationality: undefined,
  website: undefined,
  brandName: undefined,
  email: null,
  phone: null,
  photo: [],
  isVoen: null,
  isGuide: undefined,
  address: undefined,
};
export const InstitutionRegistrationModel = {
  voen: undefined,
  pin: undefined,
  objectRegisterationDate: null,
  personInChargeName: undefined,
  personInChargePosition: { az: undefined, en: undefined, ru: undefined },
  personInChargePhone: undefined,
  personInChargeEmail: undefined,
  nationality: undefined,
  isVoen: null,
  isGuide: undefined,
};
